import { useMutation } from '@tanstack/react-query';
import { ApiEndpoints } from 'types/api';

import { NewReview } from '../../../types/review';

async function addReview(review: NewReview) {
  const response = await fetch(ApiEndpoints.ADD_REVIEW, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(review),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
}

export function useReview() {
  const { mutateAsync, isError, isSuccess, reset } = useMutation({
    mutationFn: addReview,
    onError: () => {
      console.error('Webtex Reviews: Error creating review');
    },
  });

  return {
    addReview: mutateAsync,
    isError,
    isSuccess,
    reset,
  };
}
